import { render, staticRenderFns } from "./UserVerify.vue?vue&type=template&id=35e93e72&scoped=true&"
import script from "./UserVerify.vue?vue&type=script&lang=js&"
export * from "./UserVerify.vue?vue&type=script&lang=js&"
import style0 from "./UserVerify.vue?vue&type=style&index=0&id=35e93e72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e93e72",
  null
  
)

export default component.exports